import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "your-bookings-filter-modal" }
const _hoisted_2 = { class: "your-bookings-filter-modal--title" }
const _hoisted_3 = { class: "your-bookings-filter-modal--custom-date" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "your-bookings-filter-modal--custom-date-label" }, " Custom date ", -1)
const _hoisted_5 = { class: "your-bookings-filter-modal--custom-date-controls" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "date of travel", -1)
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "date of travel", -1)
const _hoisted_10 = { class: "your-bookings-filter-modal--payment-status" }
const _hoisted_11 = ["onClick"]

import { computed } from "vue";
import FormControlSelect from '@/components/FormControlSelect.vue';
import FormDatepicker from '@/components/FormDatepicker.vue';
import BottomModal from "@/components/BottomModal.vue";
import { SelectOptionType } from "@/models";
import { PaymentStatusType } from "@/models/your-bookings";
import { useBookings } from '@/store/booking'
import { useUser } from '@/store/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersModal',
  props: {
    show: { type: Boolean }
  },
  emits: ["save", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'save'): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {





const { isDriver } = useUser()
const { filter, updateFilter, errors } = useBookings()

const periodLimitChoices = computed<SelectOptionType[]>(() => {
  let days = [
    { label: "1 day", value: "1day" },
    { label: "1 week", value: "1week" },
    { label: "30 days", value: "30days" },
  ]

  if (!isDriver.value) {
    days = [...days, { label: "60 days", value: "60days" }, { label: "90 days", value: "90days" }]
  }

  return days
})

const resetFilter = () => {
  updateFilter()
}

const togglePaymentStatus = (value: PaymentStatusType) => {
  filter.value.paymentStatus = filter.value.paymentStatus == value ? null : value
}

return (_ctx: any,_cache: any) => {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createBlock(BottomModal, {
    show: __props.show,
    onClose: _cache[7] || (_cache[7] = ($event: any) => (emit('close'))),
    size: "md"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(" Filter "),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('close')), ["prevent"]))
          }, "Cancel")
        ]),
        _createVNode(FormControlSelect, {
          placeholder: "Select Period",
          modelValue: _unref(filter).periodLimit,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filter).periodLimit) = $event)),
          choices: _unref(periodLimitChoices),
          error: _unref(errors).periodLimit
        }, null, 8, ["modelValue", "choices", "error"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(FormDatepicker, {
                "enable-time-picker": false,
                "auto-apply": "",
                "close-on-auto-apply": "",
                "hide-input-icon": "",
                modelValue: _unref(filter).startDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filter).startDate) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Error, {
                error: _unref(errors).startDate
              }, null, 8, ["error"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(FormDatepicker, {
                "enable-time-picker": false,
                "auto-apply": "",
                "close-on-auto-apply": "",
                "hide-input-icon": "",
                modelValue: _unref(filter).endDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filter).endDate) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Error, {
                error: _unref(errors).endDate
              }, null, 8, ["error"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: _normalizeClass(["your-bookings-filter-modal--payment-status-btn", { active: _unref(filter).paymentStatus == 'paid' }]),
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (togglePaymentStatus('paid')), ["prevent"]))
          }, " paid ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["your-bookings-filter-modal--payment-status-btn", { active: _unref(filter).paymentStatus == 'onaccount' }]),
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (togglePaymentStatus('onaccount')), ["prevent"]))
          }, " on account ", 2)
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary btn-block your-bookings-filter-modal--save-btn",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (emit('save')), ["prevent"]))
        }, " save "),
        _createElementVNode("button", {
          class: "btn btn-primary btn-link btn-block",
          onClick: _withModifiers(resetFilter, ["prevent"])
        }, " reset filter ", 8, _hoisted_11)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})